import { type ReactNode, Children } from 'react';
import { type Style, mergeStyle } from './navbar.module.css';

interface Props {
  children: ReactNode;
  style?: Style;
}

export function Navbar(props: Props) {

  const {
    children,
    style: customStyle
  } = props;

  const style = mergeStyle(customStyle);
  const _children = Children.toArray(children);
  const topOptions = _children.filter((child: any) => !child.props.align || child.props.align === 'top' );
  const bottomOptions = _children.filter((child: any) => child.props.align === 'bottom');

  return (
    <div className={style.container}>
      <div className={style.content}>
        {topOptions}
      </div>
      <div className={style.content}>
        {bottomOptions}
      </div>
    </div>
  );
}
